import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, StatusBadge, fmtDate, inr } from "@/components/common";
import DataTable from "@/components/DataTable";
import AdvancedFilters from "@/components/AdvancedFilters";
import QuickFilters from "@/components/QuickFilters";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const QF = [{ key: "college_name", label: "Colleges" }, { key: "course", label: "Courses" }, { key: "admission_route", label: "Routes" }, { key: "counselor_name", label: "Counselors" }, { key: "last_disposition", label: "Last Dispositions" }];

export default function Applications() {
  const navigate = useNavigate();
  const { config } = useAuth();
  const [rows, setRows] = useState(null);
  const [quick, setQuick] = useState(null);
  const [display, setDisplay] = useState(null);
  const [status, setStatus] = useState("");
  const load = async () => { setRows(null); const { data } = await api.get(`/applications?status=${status}`); setRows(data); };
  useEffect(() => { load(); }, [status]); // eslint-disable-line
  const FIELDS = useMemo(() => [
    { key: "student_name", label: "Student", type: "text" }, { key: "code", label: "Application ID", type: "text" },
    { key: "college_name", label: "College", type: "text" }, { key: "course", label: "Course", type: "text" },
    { key: "admission_route", label: "Route", type: "text" }, { key: "status", label: "Status", type: "select", options: config?.application_statuses || [] },
    { key: "counselor_name", label: "Counselor", type: "text" }, { key: "application_fee", label: "Fee", type: "number" },
    { key: "application_date", label: "Date", type: "date" },
  ], [config]);
  const columns = [
    { key: "code", label: "Application", fixed: true, render: (r) => <div><div className="font-semibold text-slate-800">{r.student_name}</div><div className="text-[11px] font-mono text-slate-400">{r.code}</div></div> },
    { key: "college_name", label: "College" },
    { key: "course", label: "Course" },
    { key: "admission_route", label: "Route" },
    { key: "application_fee", label: "Fee", render: (r) => inr(r.application_fee) },
    { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
    { key: "counselor_name", label: "Counselor" },
    { key: "application_date", label: "Date", render: (r) => <span className="text-xs">{fmtDate(r.application_date)}</span> },
    { key: "last_disposition", label: "Last Disposition", hidden: true, render: (r) => r.last_disposition || "—" },
  ];
  return (
    <div>
      <PageHeader title="Applications" subtitle="Applications to specific colleges / courses" testid="applications-header">
        <Select value={status || "all"} onValueChange={(v) => setStatus(v === "all" ? "" : v)}>
          <SelectTrigger className="w-48 bg-white" data-testid="app-status-filter"><SelectValue placeholder="Status" /></SelectTrigger>
          <SelectContent className="bg-white"><SelectItem value="all">All Statuses</SelectItem>{config?.application_statuses?.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
        </Select>
      </PageHeader>
      <QuickFilters rows={rows} fields={QF} onFiltered={setQuick} testid="applications" />
      <AdvancedFilters entity="applications" fields={FIELDS} rows={quick} onFiltered={setDisplay} />
      <DataTable columns={columns} rows={display} loading={rows === null} testid="applications-table" columnsKey="applications" onRowClick={(r) => navigate(`/students/${r.student_id}`)} />
    </div>
  );
}
